export default {
  state: {
    zoneMap: [
      'D1','D2','D3','D4','D5','D6','D7','D8',
      'D9','C1','C2','C3','C4','C5','C6','D10',
      'D11','C7','B1','B2','B3','B4','C8','D12',
      'D13','C9','B5','A1','A2','B6','C10','D14',
      'D15','C11','B7','A3','A4','B8','C12','D16',
      'D17','C13','B9','B10','B11','B12','C14','D18',
      'D19','C15','C16','C17','C18','C19','C20','D20',
      'D21','D22','D23','D24','D25','D26','D27','D28'
    ],
    currentZone: 'A1',
    refreshZone: false,
    selectedLands: []
  },
  mutations: {
    changeMap(){
    },
    clickWorldMap (state, payload) {
      console.log(payload);
      state.currentZone = payload.key;
    },
    refreshZone (state, payload) {
      state.refreshZone = payload.refresh;
    },
    selectLand (state, payload) {
      for (let i = 0; i < state.selectedLands.length; ++i) {
        if (state.selectedLands[i].landId == payload.landId) {
          return;
        }
      }
      state.selectedLands.push(payload);
    },
    setSelectedLands (state, payload) {
      state.selectedLands = payload;
    },
    clearSelectedLand (state, payload) {
      for (let i = 0; i < state.selectedLands.length; ++i) {
        if (state.selectedLands[i].landId == payload.landId) {
          state.selectedLands.splice(i, 1);
          return;
        }
      }
    },
    clearSelectedLands (state, payload) {
      state.selectedLands = [];
    }
  },
};
